import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import './SearchCars.css';
import HomeSearchbar from "../Components/HomeSearchbar";
import SearchCarsSection from "../Components/SearchCarsSection";
import hondaLogo from "./assets/Logos/logo_honda.png";
import subaruLogo from "./assets/Logos/logo_subaru.png";
import toyotaLogo from "./assets/Logos/logo_toyota.png";
import nissanLogo from "./assets/Logos/logo_nissan.png";
import isuzuLogo from "./assets/Logos/logo_isuzu.png";
import mitsubishiLogo from "./assets/Logos/logo_mitsubishi.png";
import bmwLogo from "./assets/Logos/logo_bmw.png";
import mazdaLogo from "./assets/Logos/logo_mazda.png";
import suzukiLogo from "./assets/Logos/logo_suzuki.png";
import mercedesLogo from "./assets/Logos/logo_mercedes.png";
import hinoLogo from "./assets/Logos/logo_hino.png";
import hyundaiLogo from "./assets/Logos/logo_hyundai.png";
import daihatsuLogo from "./assets/Logos/logo_daihatsu.png";
import fordLogo from "./assets/Logos/logo_ford.png";
import jaguarLogo from "./assets/Logos/logo_jaguar.png";
import jeepLogo from "./assets/Logos/logo_jeep.png";
import kiaLogo from "./assets/Logos/logo_kia.png";
import landroverLogo from "./assets/Logos/logo_land-rover.png";
import lexusLogo from "./assets/Logos/logo_lexus.png";
import peugeotLogo from "./assets/Logos/logo_peugeot.png";


const makerLogos = {
  honda: hondaLogo,
  subaru: subaruLogo,
  toyota: toyotaLogo,
  nissan: nissanLogo,
  isuzu: isuzuLogo,
  mitsubishi: mitsubishiLogo,
  bmw: bmwLogo,
  mazda: mazdaLogo,
  suzuki: suzukiLogo,
  Suzuki: suzukiLogo,
  mercedes: mercedesLogo,
  hino: hinoLogo,
  hyundai: hyundaiLogo,
  DAIHATSU: daihatsuLogo,
  ford: fordLogo,
  jaguar: jaguarLogo,
  jeep: jeepLogo,
  kia: kiaLogo,
  landrover: landroverLogo,
  lexus: lexusLogo,
  peugeo: peugeotLogo,
};

// const makerLogos = {
//   honda: "/assets/Logos/logo_honda.png",
//   subaru: "/assets/Logos/logo_subaru.png",
//   toyota: "/assets/Logos/logo_toyota.png",
//   nissan: "/assets/Logos/logo_nissan.png",
// };

const SearchCars = () => {
    const [cars, setCars] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5);
    const navigate = useNavigate();

    useEffect(() => {
        fetch('https://api.mitradingjp.com/get-car-search.php')
            .then(response => response.json())
            .then(data => {
                setCars(data);
            })
            .catch(error => {
                console.error("Error fetching car details:", error);
            });
    }, []);

    // const handleViewVehicle = (carId) => {
    //     navigate(`/vehicle-details/${carId}`);
    // };
    const handleViewVehicle = (carId) => {
        navigate(`/${carId}`);
    };

    const makerMap = {};
    cars.forEach((car) => {
    const normalizedMaker = car.maker?.trim().toLowerCase();
    if (!normalizedMaker) return;
    if (!makerMap[normalizedMaker]) {
        makerMap[normalizedMaker] = {
        maker: car.maker.trim(), // display original
        image: car.images,
        total: 1,
        };
    } else {
        makerMap[normalizedMaker].total += 1;
    }
    });

//const makers = Object.values(makerMap);


//const makers = Object.values(makerMap);

    // const handleViewVehicles = (maker) => {
    //     navigate(`/${maker}`);
    // };

    // Calculate the current items to display
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = cars.slice(indexOfFirstItem, indexOfLastItem);

    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

//    const makerMap = {};
//     cars.forEach((car) => {
//     if (!makerMap[car.maker]) {
//         makerMap[car.maker] = {
//         maker: car.maker,
//         image: car.images,
//         total: 1,
//         id: car.id,
//         };
//     } else {
//         makerMap[car.maker].total += 1;
//     }
//     });
    
    
const makers = Object.values(makerMap);

    return (
        <>
            <div className="row">
                {/* Middle Column */}
                <div className="col-lg-12 col-md-12 col-sm-12 middlecol">
                    {/* <HomeSearchbar /> */}
                    <SearchCarsSection />
                    <hr className="title-line"></hr>

                        <div className="container">
                            <div className="row">
                                <div class="carousel-bg">
                                    <div class="main-title">
                                        <h2>For you to choose</h2>
                                        <p>Browse by car brand</p>
                                    </div>
                                </div>
                                {makers.map((item) => (
                                    <div className="col-md-2 my-2 col-sm-12" key={item.maker}>
                                        <div className="car-card py-2 text-center" id="logosearch">
                                        <div className="car-category-image">
                                            <img
                                            src={
                                                makerLogos[item.maker?.toLowerCase()] ||
                                                `https://api.mitradingjp.com/${item.image}`
                                            }
                                            alt={item.maker}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleViewVehicle(item.maker)}
                                            />
                                        </div>
                                        <div className="car-category-info">
                                            <h5>{item.maker}</h5>
                                            <p>Total Cars: ({item.total})</p>
                                        </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>    

                    <hr className="title-line"></hr>
                    {/* Pagination */}
                    <div className="pagination d-none">
                        {Array.from({ length: Math.ceil(cars.length / itemsPerPage) }, (_, i) => (
                            <button
                                key={i + 1}
                                onClick={() => paginate(i + 1)}
                                className={currentPage === i + 1 ? 'active' : ''}
                            >
                                {i + 1}
                            </button>
                        ))}
                    </div>
                </div>

            </div>
        </>
    );
};

export default SearchCars;